import { combineReducers } from 'redux';

import product from './hgproduct';
import order from './hgorder';

export default combineReducers({ product, order });
